export const PRODUCT = [
  { productName: "PG Gold", amount: "399" },
  { productName: "PG Silver", amount: "399" },
  { productName: "PG Platinum", amount: "399" },
];
export const ERROR_MESSAGE = {
  "User validation failed: phoneNumber: Please provide a valid phone number":
    "Please provide a valid phone number",
};
